// export const baseUrl = "/api1";
export const baseUrl = "https://ambulance.thearay.net/api";

export const mediaUrl = "https://ambulance.thearay.net/";

export const staticImage = "https://codehere.top/static/photos";

